module.exports = __webpack_public_path__ + "img/drapang2.01fcee10.jpg";